import { Children, React } from "react";

function Wizard({ page, children }) {
  //const values = initialValues;
  const pages = Children.toArray(children);

  return <form style={{ width: "95%" }}>{pages[page]}</form>;
}

export default Wizard;
